import styled from "styled-components";
import { DefaultReward } from "./icon";

interface IProps {
    color?: string;
}
export const DefaultRewardImage = ({ color }: IProps) => (
    <StyledImage color={color}>
        <DefaultReward />
    </StyledImage>
);
const StyledImage = styled.div<{ color?: string }>`
    background: ${(p) => p.color || "#676767"};
    width: 96px;
    height: 90px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
